var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.707 15.707C18.5348 15.8792 18.3057 15.9826 18.0627 15.9979C17.8196 16.0132 17.5794 15.9393 17.387 15.79L17.293 15.707L12 10.415L6.70697 15.707C6.53478 15.8792 6.30568 15.9826 6.06265 15.9979C5.81962 16.0132 5.57937 15.9393 5.38697 15.79L5.29297 15.707C5.12079 15.5348 5.01736 15.3057 5.00208 15.0627C4.9868 14.8197 5.06072 14.5794 5.20997 14.387L5.29297 14.293L11.293 8.29302C11.4652 8.12084 11.6943 8.01741 11.9373 8.00213C12.1803 7.98685 12.4206 8.06077 12.613 8.21002L12.707 8.29302L18.707 14.293C18.8944 14.4805 18.9998 14.7349 18.9998 15C18.9998 15.2652 18.8944 15.5195 18.707 15.707Z",
    fill: "#6C7275"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.11be6a85df1e928a0364c1e775bc64a7.svg";
export { ForwardRef as ReactComponent };